import React, { useEffect, useState, useRef } from 'react'
import Swal from 'sweetalert2';
import { collection, doc, getDoc, getDocs, query, Timestamp, where } from 'firebase/firestore';
import { auth, db } from '../../firebase';
import "../../App.css";
import moment from 'moment';
import { useReactToPrint } from 'react-to-print';
import Menu from '../../panel/Menu';

function Pendingreport() {

    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000
    });

    const printRef = useRef();

    const [loading, setloading] = useState(false);
    const [propertyId, setPropertyId] = useState("");
    const [fromDate, setfromDate] = useState("");
    const [toDate, settoDate] = useState("");
    const [bookingData, setbookingData] = useState([]);

    const [totalamount, settotalamount] = useState(0);
    const [paid, setpaid] = useState(0);
    const [remaining, setremaining] = useState(0);
    const [noofrooms, setnoofrooms] = useState(0);
    const [noofadults, setnoofadults] = useState(0);

    // ✅ Fetch propertyId from authroles
    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(async (user) => {
            if (user) {
                const roleSnap = await getDoc(doc(db, "authroles", user.uid));
                if (roleSnap.exists()) {
                    setPropertyId(roleSnap.data().propertyId);
                }
            }
        });

        return () => unsubscribe();
    }, []);

    const getReport = async () => {

        if (!fromDate || !toDate) {
            Toast.fire({ icon: "error", title: 'Please select From Date & To Date' });
            return;
        }

        if (!propertyId) {
            Toast.fire({ icon: "error", title: 'Property not loaded yet' });
            return;
        }

        setloading(false);
        setbookingData([]);

        const startDate = new Date(fromDate);
        startDate.setHours(0, 0, 0, 0);

        const endDate = new Date(toDate);
        endDate.setDate(endDate.getDate() + 1);

        try {

            // ✅ Filter using propertyId
            const q = query(
                collection(db, 'reservations'),
                where('propertyId', '==', propertyId),
                where('status', '!=', 'Canceled'),
                where('remaining', '>', 0),
                where('createdAt', '>=', Timestamp.fromDate(startDate)),
                where('createdAt', '<', Timestamp.fromDate(endDate))
            );

            const querySnapshot = await getDocs(q);

            const bookings = querySnapshot.docs.map(doc => ({
                id: doc.id,
                data: doc.data()
            }));

            setbookingData(bookings);

            // ✅ Calculations
            const total = querySnapshot.docs.reduce(
                (sum, doc) => sum + (doc.data().totalamount || 0), 0
            );

            const paidAmount = querySnapshot.docs.reduce(
                (sum, doc) => sum + (doc.data().advance || 0), 0
            );

            const pending = querySnapshot.docs.reduce(
                (sum, doc) => sum + (doc.data().remaining || 0), 0
            );

            const totalAdults = querySnapshot.docs.reduce(
                (sum, doc) => sum + (parseFloat(doc.data().adults) || 0), 0
            );

            const totalRooms = querySnapshot.docs.reduce(
                (sum, doc) => sum + (doc.data().rooms?.length || 0), 0
            );

            settotalamount(total.toFixed(0));
            setpaid(paidAmount.toFixed(0));
            setremaining(pending.toFixed(0));
            setnoofadults(totalAdults);
            setnoofrooms(totalRooms);

            setloading(true);

        } catch (error) {
            console.log(error.message);
            
            Toast.fire({ icon: "error", title: error.message });
        }
    };

    const handlePrint = useReactToPrint({
        content: () => printRef.current,
    });

    return (
        <div>
            <Menu />
            <div className="content-wrapper">
                <section className="content mt-2">
                    <div className="container-fluid">

                        <button className="btn btn-secondary">
                            || All Pending Report ||
                        </button>

                        <br /><br />

                        <div className="card card-primary card-outline">
                            <div className="card-body">
                                <div className='row'>

                                    <div className='col-sm-4'>
                                        <label>From Date</label>
                                        <input
                                            type='date'
                                            value={fromDate}
                                            onChange={(e) => {
                                                setfromDate(e.target.value);
                                                setloading(false);
                                            }}
                                            className='form-control'
                                        />
                                    </div>

                                    <div className='col-sm-4'>
                                        <label>To Date</label>
                                        <input
                                            type='date'
                                            value={toDate}
                                            onChange={(e) => {
                                                settoDate(e.target.value);
                                                setloading(false);
                                            }}
                                            className='form-control'
                                        />
                                    </div>

                                    <div className='col-sm-3'>
                                        <br />
                                        <button
                                            className='btn btn-info'
                                            onClick={getReport}
                                        >
                                            Get Report
                                        </button>
                                    </div>

                                </div>
                            </div>
                        </div>

                        {loading && (
                            <>
                                <div className="card card-primary card-outline" ref={printRef}>
                                    <div className="card-body">

                                        <h5 className="text-center">PENDING REPORT</h5>

                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Sr No</th>
                                                    <th>Customer</th>
                                                    <th>Mobile</th>
                                                    <th>Checkin</th>
                                                    <th>Checkout</th>
                                                    <th>Rooms</th>
                                                    <th>Adults</th>
                                                    <th>Total</th>
                                                    <th>Paid</th>
                                                    <th>Pending</th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                                {bookingData.map((item, index) => (
                                                    <tr key={item.id}>
                                                        <td>{index + 1}</td>
                                                        <td>{item.data.customers?.custname}</td>
                                                        <td>{item.data.customers?.mobile}</td>
                                                        <td>
                                                            {moment(item.data.checkindate).format('DD/MM/YYYY')}
                                                        </td>
                                                        <td>
                                                            {moment(item.data.checkoutdate).format('DD/MM/YYYY')}
                                                        </td>
                                                        <td>{item.data.rooms?.length}</td>
                                                        <td>{item.data.adults}</td>
                                                        <td>{item.data.totalamount?.toFixed(0)}</td>
                                                        <td>{item.data.advance?.toFixed(0)}</td>
                                                        <td>{item.data.remaining?.toFixed(0)}</td>
                                                    </tr>
                                                ))}

                                                <tr style={{ fontWeight: "bold", background: "#f0f0f0" }}>
                                                    <td colSpan="5">TOTAL</td>
                                                    <td>{noofrooms}</td>
                                                    <td>{noofadults}</td>
                                                    <td>{totalamount}</td>
                                                    <td>{paid}</td>
                                                    <td>{remaining}</td>
                                                </tr>

                                            </tbody>
                                        </table>

                                    </div>
                                </div>

                                <center>
                                    <button
                                        className='btn btn-success'
                                        onClick={handlePrint}
                                    >
                                        Print Report
                                    </button>
                                </center>
                            </>
                        )}

                    </div>
                </section>
            </div>
        </div>
    );
}

export default Pendingreport;